export default "__VITE_ASSET__04179fb2__"